import KinerjaLayout from 'app/KinerjaPage/components/KinerjaDemoLayout'
import { PenilaianKinerja } from 'app/KinerjaPage/pages/PelaksanaanV2/PenilaianKinerja/PenilaianKinerja'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    if (
      !toggle?.['kinerja-enabled'] ||
      !toggle?.['kinerja-pelaksanaan-enabled'] ||
      !toggle?.['kinerja-penilaian-demo-mode-enabled']
    ) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    return {
      props: {},
    }
  },
})

const Page: KinerjaApp = () => {
  return <PenilaianKinerja npsn="demo" />
}

export default Page

Page.Layout = KinerjaLayout

Page.layoutOpts = {}
